import styled from 'styled-components';
import { useLocation, Link } from "react-router-dom";
import V4LOGOWhite from '../assets/V4LOGOWhite.png';

const Header = () => {
    const location = useLocation();
    return(
      <HeaderBox>
        <LogoLink to="/" aria-label="K360°REA 홈으로 이동">
          <Headerimg src={V4LOGOWhite} alt="K360°REA" />
        </LogoLink>
        <Headerinfo aria-label="주요 메뉴">
          <StyledLink to="/Local">
            <Span isActive={location.pathname.toLowerCase() === "/local"}>지역정보</Span>
          </StyledLink>
          <StyledLink to="/Load">
            <Span isActive={location.pathname.toLowerCase() === "/load"}>도로정보</Span>
          </StyledLink>
        </Headerinfo>
      </HeaderBox>
    );
};

export default Header;
const StyledLink = styled(Link)`
  text-decoration: none;
`;

const LogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
`;


const HeaderBox = styled.div`
  height: 76px;
  padding: 0 clamp(20px, 4vw, 48px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #173741;

  @media (max-width: 560px) {
    padding: 0 20px;
  }
`;

const Headerimg = styled.img`
  width: clamp(126px, 12vw, 160px);
  height: auto;

  @media (max-width: 560px) {
    width: 112px;
  }
`;
const Headerinfo = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(20px, 4vw, 52px);

  @media (max-width: 560px) {
    gap: 16px;
  }
`;


const Span = styled.span`
  display: inline-block;
  padding: 8px 0;
  border-bottom: 1px solid ${({ isActive }) => (isActive ? "#b8e5eb" : "transparent")};
  color: ${({ isActive }) => (isActive ? "#FFFFFF" : "rgba(255, 255, 255, 0.62)")};
  font-size: clamp(0.88rem, 1.3vw, 1rem);
  line-height: 1.2;
  font-weight: ${({ isActive }) => (isActive ? "850" : "600")};
  letter-spacing: -0.025em;

  @media (max-width: 560px) {
    font-size: 0.82rem;
  }
`;
